import { useContext, useState } from "react";
import { createContext } from "react";

const LoadingContext = createContext({});

const LoadingProvider = ({ children }) => {
    const [data, setData] = useState({});
    const update = ({ message, percentage }) => {
        setData({ message: message, percentage: percentage});
    };
    let value = { data, update };
    return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}

const useLoading = () => {
    return useContext(LoadingContext);
}

const useLoadingData = () => {
    return useContext(LoadingContext).data;
}

export { LoadingProvider, useLoading, useLoadingData };